import { render, staticRenderFns } from "./UpscalesButton.vue?vue&type=template&id=168addec&scoped=true"
import script from "./UpscalesButton.vue?vue&type=script&lang=js"
export * from "./UpscalesButton.vue?vue&type=script&lang=js"
import style0 from "./UpscalesButton.vue?vue&type=style&index=0&id=168addec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168addec",
  null
  
)

export default component.exports